module.exports = __webpack_public_path__ + "img/dia_da_consciencia_negra.b6b68ee8.svg";